import { createSlice } from "@reduxjs/toolkit";

const initialState: any = { lineItems: []}

const shoppingListItemsSlice = createSlice({
    name: "shoppingListItems",
    initialState,
    reducers: {
        addItem: (state, action) => {
            state.lineItems.push(action.payload);
        },
        removeItem: (state, action) => {
            state.lineItems.splice(action.payload, 1);
        },
        emptyItems: (state, action) => {
            state.lineItems = [];
        },             
    }
})

// actions
export const {addItem, removeItem, emptyItems } = shoppingListItemsSlice.actions;

// selector
export const shoppingListItemsSelector = (state: any) => state.shoppingListItems.lineItems;

// The reducer
export default shoppingListItemsSlice.reducer;